import React, { useEffect, useState, useContext } from 'react';
import { privateAxiosInstance } from '../api/axios';
import { AuthContext } from '../contexts/AuthContext';

const Settings = () => {
    const { authState } = useContext(AuthContext);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();

        const fetchUserInfo = async () => {
            try {
                const response = await privateAxiosInstance.get('/api/v1/users/me/', {
                    signal: abortController.signal,
                });
                setUserInfo(response.data);
            } catch (err) {
                const msg = err.response?.data?.detail || 'Failed to load user information.';
                setError(msg);
            } finally {
                setLoading(false);
            }
        };

        fetchUserInfo();

        return () => abortController.abort();
    }, []);

    if (loading) {
        return (
            <main className="page-container">
                <h1>Settings</h1>
                <p>Loading...</p>
            </main>
        );
    }

    if (error) {
        return (
            <main className="page-container">
                <h1>Settings</h1>
                <p>{error}</p>
            </main>
        );
    }

    return (
        <main className="page-container">
            <h1>Settings</h1>
            <ul>
                <li><strong>ID:</strong> {userInfo.id}</li>
                <li><strong>Username:</strong> {userInfo.username}</li>
                <li><strong>Google ID:</strong> {userInfo.google_sub}</li>
                <li><strong>Active:</strong> {userInfo.is_active ? 'Yes' : 'No'}</li>
                <li><strong>Staff:</strong> {userInfo.is_staff ? 'Yes' : 'No'}</li>
                <li><strong>Review Count:</strong> {userInfo.review_count}</li>
                <li><strong>School:</strong> {authState.school?.name || userInfo.school}</li>
            </ul>
        </main>
    );
};

export default Settings;
